var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 9.5H10.6667V10.8333H12M12 6.83333H10.6667V8.16667H12M13.3334 12.1667H8.00004V10.8333H9.33337V9.5H8.00004V8.16667H9.33337V6.83333H8.00004V5.5H13.3334M6.66671 4.16667H5.33337V2.83333H6.66671M6.66671 6.83333H5.33337V5.5H6.66671M6.66671 9.5H5.33337V8.16667H6.66671M6.66671 12.1667H5.33337V10.8333H6.66671M4.00004 4.16667H2.66671V2.83333H4.00004M4.00004 6.83333H2.66671V5.5H4.00004M4.00004 9.5H2.66671V8.16667H4.00004M4.00004 12.1667H2.66671V10.8333H4.00004M8.00004 4.16667V1.5H1.33337V13.5H14.6667V4.16667H8.00004Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCompany);
export default __webpack_public_path__ + "static/media/mdi_company.ad5d684191fe4020907277059169369c.svg";
export { ForwardRef as ReactComponent };